import { render } from "./ProviderLIst.vue?vue&type=template&id=c5a5c11e"
import script from "./ProviderLIst.vue?vue&type=script&lang=js"
export * from "./ProviderLIst.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__